export default __webpack_public_path__ + "static/media/travelGuru.2a666370.PNG";